/**
 * API Configuration constants
 */

// Base URL for API requests
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// API endpoint paths
export const API_ENDPOINTS = {
  AUTH: '/api/auth',
  USERS: '/api/users',
  PRODUCTS: '/api/products',
  CATEGORIES: '/api/product-categories',
  CUSTOMERS: '/api/customers',
  SUPPLIERS: '/api/suppliers',
  SALES_ORDERS: '/api/sales-orders',
  PURCHASE_ORDERS: '/api/purchase-orders',
  NOTIFICATIONS: '/api/notifications'
};

export default {
  API_BASE_URL,
  API_ENDPOINTS
}; 